import { render, staticRenderFns } from "./scheduleList-news.vue?vue&type=template&id=11937828&scoped=true"
import script from "./scheduleList-news.vue?vue&type=script&lang=js"
export * from "./scheduleList-news.vue?vue&type=script&lang=js"
import style0 from "./scheduleList-news.vue?vue&type=style&index=0&id=11937828&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11937828",
  null
  
)

export default component.exports